<template>
    <div class="about">
        <h2 class="title is-4">運営情報</h2>
        <hr/>
        <p>雨のネコ社</p>
        <hr/>
        <p>ホームページ</p>
        <p><a href="https://ameneko.com/">https://ameneko.com/</a></p>
        <hr/>
        <p>代表：加藤 登</p>
        <hr/>
        <p>運営ブログ</p>
        <p><a href="https://www.katonobo.com/">かとのぼのマイコード・マイライフ</a></p>
        <hr/>
        <p>ツイッターアカウント</p>
        <p><a href="https://twitter.com/katonobo1">@katonobo1</a></p>
    </div>
</template>

<script>
export default {
    mounted(){
        const title = "運営情報｜エモーションダイアリー"
        const description = "運営情報のページ"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    } 

}
</script>

<style scoped>
.about{
    text-align:center;
    max-width: 800px;
    margin:auto;
    font-weight: bold;
    font-size: 1.1em;
}
</style>